export default class TimeUtils {

    static translatedDays = [
        {es: 'domingo', ca: 'diumenge', en: 'Sunday', de: 'Sonntag'},
        {es: 'lunes', ca: 'dilluns', en: 'Monday', de: 'Montag'},
        {es: 'martes', ca: 'dimarts', en: 'Tuesday', de: 'Dienstag'},
        {es: 'miércoles', ca: 'dimecres', en: 'Wednesday', de: 'Mittwoch'},
        {es: 'jueves', ca: 'dijous', en: 'Thursday', de: 'Donnerstag'},
        {es: 'viernes', ca: 'divendres', en: 'Friday', de: 'Freitag'},
        {es: 'sábado', ca: 'dissabte', en: 'Saturday', de: 'Samstag'}
     ];

     static translatedMonths = [
        {ca:'gener', es:'enero', en:'january', de:'januar'},
        {ca:'febrer', es:'febrero', en:'february', de:'jebruar'},
        {ca:'març', es:'marzo', en:'march', de:'marsch'},
        {ca:'abril', es:'abril', en:'april', de:'april'},
        {ca:'maig', es:'mayo', en:'may', de:'mai'},
        {ca:'juny', es:'junio', en:'june', de:'juni'},
        {ca:'juliol', es:'julio', en:'july', de:'juli'},
        {ca:'agost', es:'agosto', en:'august', de:'august'},
        {ca:'setembre', es:'septiembre', en:'september', de:'september'},
        {ca:'octubre', es:'octubre', en:'october', de:'oktober'},
        {ca:'novembre', es:'noviembre', en:'november', de:'november'},
        {ca:'desembre', es:'diciembre', en:'december', de:'dezember'},
     ];

    static getTime(duration){
        let date = new Date(duration);
        let hours = date.getHours().toString();
        let minutes = date.getMinutes().toString();
        if(parseInt(hours)<10)
            hours = '0'+hours;
        if(parseInt(minutes)<10)
            minutes = '0'+minutes;
        return hours + ':' + minutes;
    }

    static isTime(time){
        return /^([0-1][0-9]|2[0-3]):[0-5][0-9](:[0-5][0-9])?$/.test(time);
    }

    static getFormatedTime(total){
        let hoursDuration = total / 60 >= 1 ? parseInt(total / 60 as any) : null;
        let minutesDuration = hoursDuration ? total % 60 : total;
        const textTotal = hoursDuration ? `${hoursDuration} h ${minutesDuration} min` : `${minutesDuration} min`;
        return textTotal;
    }

    static convertFromJulianToDate(jd) {
        let millis = (jd - 2440587.5) * 86400000;
        let dateLocal = new Date(millis);
        return dateLocal;
    }

    static timeToMil(t) {
        return Number(t.split(':')[0]) * 60 * 60 * 1000 + Number(t.split(':')[1]) * 60 * 1000;
    }

    static convertTime12to24(time) {
        var hours = parseInt(time?.substr(0, 2));
        if(time?.indexOf('am') !== -1 && hours === 12) {
            time = time?.replace('12', '0');
        }
        if(time?.indexOf('pm')  !== -1 && hours < 12) {
            time = time.replace(time?.substr(0, 2), (hours + 12));
        }
        return time?.replace(/(am|pm)/, '');
    }

    static getTimePM_AM(time){
        let hours = parseInt(time?.substr(0,2)) as any;
        let minutes = parseInt(time?.substr(3,4)) as any;
        let pmAm = 'am';
        if(hours / 12 >= 1) {
            pmAm = 'pm';
            if(hours / 12 !== 1)
                hours = hours % 12;
        }
        return String(hours).padStart(2,'0') + ':' + String(minutes).padStart(2, '0') + pmAm;
    }

    static getSimpleTime(time){
        let hours = time?.substr(0,2);
        let minutes = time?.substr(3,2);
        return hours+':'+minutes;
    }

    static getTimePM_AMByHoursMinutes(hours, minutes) {
        let pmAm = 'am';

        if (hours / 12 > 1) {
            pmAm = 'pm';
            hours = '0' + (hours % 12);
        }

        if (minutes < 10) {
            minutes = '0' + minutes;
        }

        return hours + ':' + minutes + pmAm;
    }

    static getDate(date){
        date=new Date(date);
        let day= date.getDate();
        let month= date.getMonth()+1;
        let year= date.getFullYear();
        if(day<10)
            day='0'+day;
        if(month<10)
            month='0'+month;
        return month + '-' + day + '-' + year;
    }

    static getFullDate( _date, lang, noTime=false ) {

        const date = new Date(_date);
        let month;
        let day= date.getDate();
        let year= date.getFullYear();
        let data = new Date(date.toString());

        switch (data.getMonth()){
            case 0: month={ca:'gener', es:'enero', en:'january', de:'januar'}; break;
            case 1: month={ca:'febrer', es:'febrero', en:'february', de:'jebruar'}; break;
            case 2: month={ca:'març', es:'marzo', en:'march', de:'marsch'}; break;
            case 3: month={ca:'abril', es:'abril', en:'april', de:'april'}; break;
            case 4: month={ca:'maig', es:'mayo', en:'may', de:'mai'}; break;
            case 5: month={ca:'juny', es:'junio', en:'june', de:'juni'}; break;
            case 6: month={ca:'juliol', es:'julio', en:'july', de:'juli'}; break;
            case 7: month={ca:'agost', es:'agosto', en:'august', de:'august'}; break;
            case 8: month={ca:'setembre', es:'septiembre', en:'september', de:'september'}; break;
            case 9: month={ca:'octubre', es:'octubre', en:'october', de:'oktober'}; break;
            case 10: month={ca:'novembre', es:'noviembre', en:'november', de:'november'}; break;
            case 11: month={ca:'desembre', es:'diciembre', en:'december', de:'dezember'}; break;
            default: month= 'Error'; break;
        }
        const dateResult = (lang === 'en')
        ? `${month[lang]} ${day}, ${year}`
        : `${day} ${month[lang]} ${year}`;

        return !noTime ? dateResult : `${dateResult} ${this.getTime(date)}`;
    };

    static stringFormatDate = (date, lang)=>{
        if(!date) return '';
        const separator = date.includes('/') ? '/' : '-';
        const isDateTime = (date?.split(' ')?.length > 1);
        const dateTime = isDateTime ? date?.split(' ')[0] : date;
        const dateString = dateTime?.slice(0, 4).includes('-') || dateTime?.slice(0, 4).includes('/')
        ? dateTime
        : dateTime?.split(separator).reverse().join(separator);
        const f = dateString?.split(separator);
        const day = f[0];
        const MONTH = f[1];
        let month;
        let dateResult;
        const year = f[2]?.split(' ')[0] || null;
        const time = isDateTime ? date?.split(' ')[1] : null;

        switch (Number(MONTH) -1){
            case 0: month ={ca:'gener', es:'enero', en:'january', de:'januar'}; break;
            case 1: month ={ca:'febrer', es:'febrero', en:'february', de:'jebruar'}; break;
            case 2: month ={ca:'març', es:'marzo', en:'march', de:'marsch'}; break;
            case 3: month ={ca:'abril', es:'abril', en:'april', de:'april'}; break;
            case 4: month ={ca:'maig', es:'mayo', en:'may', de:'mai'}; break;
            case 5: month ={ca:'juny', es:'junio', en:'june', de:'juni'}; break;
            case 6: month ={ca:'juliol', es:'julio', en:'july', de:'juli'}; break;
            case 7: month ={ca:'agost', es:'agosto', en:'august', de:'august'}; break;
            case 8: month ={ca:'setembre', es:'septiembre', en:'september', de:'september'}; break;
            case 9: month ={ca:'octubre', es:'octubre', en:'october', de:'oktober'}; break;
            case 10: month={ca:'novembre', es:'noviembre', en:'november', de:'november'}; break;
            case 11: month={ca:'desembre', es:'diciembre', en:'december', de:'dezember'}; break;
            default: month= 'Error'; break;
        }

        switch (lang){
            case 'ca': dateResult=`${day} de ${month[lang]} de ${year} ${time ? `a les ${time}`:''}`; break;
            case 'es': dateResult=`${day} de ${month[lang]} de ${year} ${time ? `a las ${time}`:''}`; break;
            case 'de': dateResult=`${day} ${month[lang]} ${year} ${time ? `um ${time}`:''}`; break;
            case 'en': dateResult=`${month[lang]} ${day}, ${year}, ${time ? `at ${time}`:''}`; break;
            default: dateResult= 'Error'; break;
        }
        return dateResult;
    };

    static getPlanDate(date) {
        let split = date.split('-');
        return split[1]+'-'+split[0]+'-'+split[2];
    }

    static getFormattedDateToPicker = (date)  => {
        let day;
        let month;
        let data = new Date(date.toString());
        switch (data.getDay()){
            case 1: day='lun'; break;
            case 2: day='mar'; break;
            case 3: day='miér'; break;
            case 4: day='jue'; break;
            case 5: day='vie'; break;
            case 6: day='sáb'; break;
            case 0: day='dom'; break;
            default: day=''; break;
        }
        switch (data.getMonth()){
            case 0: month='ene'; break;
            case 1: month='feb'; break;
            case 2: month='mar'; break;
            case 3: month='abr'; break;
            case 4: month='may'; break;
            case 5: month='jun'; break;
            case 6: month='jul'; break;
            case 7: month='ago'; break;
            case 8: month='sep'; break;
            case 9: month='oct'; break;
            case 10: month='nov'; break;
            case 11: month='dic'; break;
            default: month=''; break;
        }
        let res = `${day}, ${data.getDate()} ${month}`;
        return res;
    };

    static getFormattedDate = (date, lang)  => {
        let day;
        let month;
        let data = new Date(date?.toString());
        switch (data.getDay()){
            case 0: day = TimeUtils.translatedDays[0][lang]; break;
            case 1: day = TimeUtils.translatedDays[1][lang]; break;
            case 2: day = TimeUtils.translatedDays[2][lang]; break;
            case 3: day = TimeUtils.translatedDays[3][lang]; break;
            case 4: day = TimeUtils.translatedDays[4][lang]; break;
            case 5: day = TimeUtils.translatedDays[5][lang]; break;
            case 6: day = TimeUtils.translatedDays[6][lang]; break;
            default: day=''; break;
        }
        switch (data.getMonth()){
            case 0: month= TimeUtils.translatedMonths[0][lang]; break;
            case 1: month= TimeUtils.translatedMonths[1][lang]; break;
            case 2: month= TimeUtils.translatedMonths[2][lang]; break;
            case 3: month= TimeUtils.translatedMonths[3][lang]; break;
            case 4: month= TimeUtils.translatedMonths[4][lang]; break;
            case 5: month= TimeUtils.translatedMonths[5][lang]; break;
            case 6: month= TimeUtils.translatedMonths[6][lang]; break;;
            case 7: month= TimeUtils.translatedMonths[7][lang]; break;
            case 8: month= TimeUtils.translatedMonths[8][lang]; break;
            case 9: month= TimeUtils.translatedMonths[9][lang]; break;
            case 10: month= TimeUtils.translatedMonths[10][lang]; break;
            case 11: month= TimeUtils.translatedMonths[11][lang]; break;
            default: month=''; break;
        }
        let res = lang === 'en'
        ? `${day}, ${month} ${data.getDay()}`
        : `${day} ${data.getDate()} ${month}`;
        return res;
    };

    static getDay = (date)  => {
        let day;
        let data = new Date(date.toString());
        switch (data.getDay()){
            case 1: day='Lunes'; break;
            case 2: day='Martes'; break;
            case 3: day='Mércoles'; break;
            case 4: day='Jueves'; break;
            case 5: day='Viernes'; break;
            case 6: day='Sábado'; break;
            case 0: day='Domingo'; break;
            default: day=''; break;
        }
        let res = day;
        return res;
    };

    static getYear = (_date)  => {
        const date = new Date(_date);
        let year= date.getFullYear();
        return year;
    };

    static getCurrentYear = ()  => {
        const date = new Date();
        let year= date.getFullYear();
        return year;
    };

    static timeTilNow(fecha, hora) { //TODO: esta funcion no va bien
        let retorno = '';
        const ahora = new Date();
        const diaAhora = new Date(
          ahora.getFullYear() +
            '-' +
            ( String(ahora.getMonth() + 1 ).padStart(2, '0') ) +
            '-' +
            ( String(ahora.getDate()).padStart(2, '0') ) +
            'T' +
            ( String(ahora.getHours()).padStart(2, '0') ) +
            ':' +
            ( String(ahora.getMinutes()).padStart(2, '0') ) +
            ':00',
        );
        const [dia, mes, anyo] = fecha.split('/');
        const horaMinutosSplit = hora.split(':');
        let diaHora = new Date(anyo + '-' + mes + '-' + dia);
        if (horaMinutosSplit[0] === '24') { // si son mas de las 12
            diaHora.setDate(diaHora.getDate() + 1);
            diaHora.setHours(0, parseInt(horaMinutosSplit[1], 0));
        } else {
            diaHora = new Date(anyo + '-' + mes + '-' + dia + 'T' + hora);
        }
        const diferencia = (diaHora.getTime() - diaAhora.getTime()) / 1000 / 60;
        const horasDiff = Math.trunc(diferencia / 60);
        const minutos = diferencia - 60 * horasDiff;
        if (horasDiff > 0) {
            if(horasDiff > 23){
                retorno = `${dia}/${mes}/${anyo}`;
            } else {
                retorno +=  horasDiff + ' h ' + Math.trunc(minutos) + ' min';
            }
        } else if (minutos >= 1){
            retorno += Math.trunc(minutos) + ' min';
        } else return '';
        return retorno;
      }
}
